<template>
  <ul class="fast_select">
    <span><slot v-if="showSlot" /></span>
    <li v-for="(item, k) in fastlinks" :key="k" class="c-quick-pick__item">
      <a
        class="c-quick-pick__link c-link"
        href=""
        @click.prevent="clickItem(item)"
      >
        {{ item.name }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'FastLinks',
  props: {
    fastlinks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showSlot() {
      return Boolean(this.fastlinks.length)
    },
  },
  methods: {
    clickItem(item) {
      this.$emit('selectedItem', item)
    },
  },
}
</script>
